import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Header } from '@/components/layout';
import styles from './LoadingView.module.css';

export const LoadingView: React.FC = () => (
  <>
    <Header />
    <div className={styles.loadingContainer}>
      <ProgressSpinner
        style={{ width: '50px', height: '50px' }}
        strokeWidth="4"
      />
      <p className={styles.loadingText}>Loading analysis...</p>
    </div>
  </>
);
